
import { defineComponent } from "vue";

export default defineComponent({
  name: "Subtitle",
  props: {
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: null
    }
  }
});
